import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useState } from "react";
import { Button } from "react-bootstrap";

function DepotUserHome() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Home" activeSubMenu="DepotUserHome" subMenuPermission="depotuser:home:view" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div>
            <div className="py-1">
              <Button className="btn btn-sm bg-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">DepotUser Home</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12" style={{ marginTop: 120, height: '800px' }}>
        <h3>DepotUser Home</h3>
      </div>
    </div>
  );

}

export default DepotUserHome;

